import React from "react";
import { Card } from "primereact/card";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
import { isCivilDefenseUser } from "src/utils/helpers";
const DashboardSLACard = () => {
  const { t } = useTranslation(["common", "dashboard"]);
  const { meetingSla } = useSelector(
    (state: any) => state.dashboard.dashboardCardsData
  );

  const isDashboardCardsDataLoaded = useSelector(
    (state: any) => state.dashboard.isDashboardCardsDataLoaded
  );
  return (
    <Card className="card card-1-2">
      <div className="card-content">
        <div className="d-flex gap-2 justify-content-start align-items-center">
          <div className="circle inactive p-4 d-flex justify-content-center align-items-center">
            <HandshakeOutlinedIcon />{" "}
          </div>
          <h6 className="card-title">{isCivilDefenseUser()? t("requestsMeetingSLA"):t("bmcRequestMeetingSLA")}</h6>
        </div>
        {isDashboardCardsDataLoaded && (
          <div className="card-data mt-4">
            <h1 className="weight-600">{meetingSla}%</h1>
          </div>
        )}

        {!isDashboardCardsDataLoaded && <ProgressSpinner />}
      </div>
    </Card>
  );
};

export default DashboardSLACard;
